//讨论
export const SK_DISCUSS_LIST = 'sk_discuss_list'
//讨论详情
export const SK_DISCUSS_DETAILS = 'sk_discuss_Details'
//讨论添加
export const SK_DISCUSS_ADD = 'sk_discuss_add'
//讨论结束
export const SK_DISCUSS_OVER = 'sk_discuss_over'
//讨论结束
export const SK_DISCUSS_RES = 'sk_discuss_res'
//讨论结束--词云
export const SK_DISCUSS_WORD = 'sk_discuss_word'
//讨论结束点赞
export const SK_DISCUSS_PRAISE = 'sk_discuss_praise'
